import Game from "./Game";
import "../index.css";

interface GamesProps {
  events:
    | Array<Record<string, unknown>>
    | Record<string, Record<string, unknown>>;
  rules: { [key: string]: unknown };
  showActive: boolean;
  showMyGames: boolean;
  showOnlyAlerts: boolean;
  showSport: string;
  book: string;
}

export default function Games({
  events,
  rules,
  showActive,
  showMyGames,
  showOnlyAlerts,
  showSport,
  book,
}: GamesProps) {
  const filteredItems: Array<Record<string, unknown>> = [];

  // Cast events to array type since we know the structure
  const eventsArray = events as Array<Record<string, unknown>>;

  const now = new Date();
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + 3);

  for (const event of eventsArray[0] as unknown as Iterable<
    Record<string, unknown>
  >) {
    if (String(event.sport_id) === showSport || showSport === "0") {
      if (!showMyGames || event["watching"]) {
        if (!showOnlyAlerts || (event["id"] as number) in rules) {
          const start_time = new Date(event["start_time"] as string);
          event["far_future"] = false;
          if (start_time < now && showActive) {
            event["future"] = false;
            filteredItems.push(event);
          } else if (start_time > now && !showActive) {
            event["future"] = true;
            if (start_time > futureDate) {
              event["far_future"] = true;
            }
            filteredItems.push(event);
          }
        }
      }
    }
  }

  // Object.keys(events).forEach((key) => {
  //     if (key === showSport || showSport === "ALL") {
  //         const event_list = events[key]["events"];
  //         Object.keys(event_list).forEach((event_id) => {
  //             const current_event = event_list[event_id];
  //             if (!showMyGames || current_event["watching"]) {
  //                 const start_time = new Date(new Date(current_event["start_time"]));
  //                 if (!showOnlyAlerts || current_event["ruleHit"]) {
  //                     if (start_time < now && showActive) {
  //                         filteredItems[event_id] = current_event;
  //                         filteredItems[event_id]["future"] = false;
  //                         filteredItems[event_id]["far_future"] = false;
  //                     } else if (start_time > now && !showActive) {
  //                         filteredItems[event_id] = current_event;
  //                         filteredItems[event_id]["future"] = true;
  //                         if (start_time > futureDate) {
  //                             filteredItems[event_id]["far_future"] = true;
  //                         } else {
  //                             filteredItems[event_id]["far_future"] = false;
  //                         }
  //                     }
  //                 }
  //             }
  //         });
  //     }
  // })

  return (
    <div>
      {filteredItems.length === 0 ? (
        <div>
          <p
            className="font_family_base"
            style={{
              textAlign: "center",
              marginTop: "2rem",
              marginBottom: "2rem",
            }}
          >
            No active games matching your criteria
          </p>
        </div>
      ) : (
        filteredItems.map((item: { [key: string]: unknown }) => (
          <Game
            key={String(item["id"])}
            book={book}
            game={item}
            showActive={showActive}
            rules={
              String(item["id"]) in rules
                ? (rules[String(item["id"])] as
                    | Array<Record<string, unknown>>
                    | Record<string, Record<string, unknown>>)
                : []
            }
          />
        ))
      )}
    </div>
  );
}
